var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.69995 6.90814V8.40814H12.7V6.90814C12.7 5.52689 11.5812 4.40814 10.2 4.40814C8.8187 4.40814 7.69995 5.52689 7.69995 6.90814ZM5.69995 8.40814V6.90814C5.69995 4.42377 7.71558 2.40814 10.2 2.40814C12.6843 2.40814 14.7 4.42377 14.7 6.90814V8.40814H15.2C16.3031 8.40814 17.2 9.30502 17.2 10.4081V16.4081C17.2 17.5113 16.3031 18.4081 15.2 18.4081H5.19995C4.09683 18.4081 3.19995 17.5113 3.19995 16.4081V10.4081C3.19995 9.30502 4.09683 8.40814 5.19995 8.40814H5.69995Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.4938edcdf1b8f049d166c8e5dc18361c.svg";
export { ForwardRef as ReactComponent };